import { BoxV2 as Box, Flex } from 'portal-commons';
import React, { FunctionComponent } from 'react';
import { Tooltip, ClickAwayListener, makeStyles } from '@material-ui/core';
import { faEye } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toastFlashMessage } from '@/utils';

const useStyles = makeStyles({
  customTooltip: {
    minWidth: '526px',
    maxWidth: '526px',
    padding: 0,
    marginTop: '5px',
    borderRadius: '3px',
    boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.25)',
    overflow: 'hidden',
  },
});

interface VettingTokenTooltipProps {
  token: string;
  placement?: React.ComponentProps<typeof Tooltip>['placement'];
}

const VettingTokenTooltip: FunctionComponent<VettingTokenTooltipProps> = ({
  token,
  placement = 'bottom-end',
}) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  return (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <Tooltip
        id="vettingTokenTooltip"
        PopperProps={{
          disablePortal: true,
          popperOptions: {
            positionFixed: true,
            modifiers: {
              preventOverflow: {
                enabled: true,
                boundariesElement: 'window',
              },
            },
          },
        }}
        disableFocusListener
        disableHoverListener
        disableTouchListener
        open={open}
        placement={placement}
        classes={{
          tooltip: classes.customTooltip,
        }}
        title={
          <Box sx={{ color: 't.black80', fontSize: 'H300' }}>
            <Box
              sx={{
                padding: '12px 18px',
                color: 't.white',
                backgroundColor: 't.blue100',
                fontWeight: 600,
                fontSize: '16px',
                lineHeight: 'normal',
              }}
            >
              Please see the vetting token below:
            </Box>
            <Flex
              sx={{
                flexDirection: 'row',
                alignItems: 'center',
                gap: '4px',
                padding: '13px 18px',
                color: 't.grey900',
                background: 't.white',
                fontWeight: 400,
              }}
            >
              <Box
                sx={{
                  flex: 1,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
              >
                {token}
              </Box>
              <Box
                sx={{
                  color: 't.blue100',
                  textDecoration: 'underline',
                  pointerEvents: 'auto',
                  cursor: 'pointer',
                }}
                onClick={(event) => {
                  event.stopPropagation();
                  navigator.clipboard.writeText(token);
                  toastFlashMessage(
                    'Vetting token has been copied to your clipboard'
                  );
                }}
              >
                copy
              </Box>
            </Flex>
          </Box>
        }
        onClose={() => setOpen(false)}
      >
        <Box
          onClick={() => setOpen(!open)}
          sx={{
            marginLeft: '-3px',
            backgroundColor: open ? 't.paleBlue400' : 'transparent',
            cursor: 'pointer',
            borderRadius: '50%',
            '&:hover': {
              backgroundColor: 't.paleBlue400',
            },
            '+ .MuiTooltip-popper': {
              left: '100px !important',
            },
          }}
          data-testid="vettingTokenTooltipButton"
        >
          <FontAwesomeIcon style={{ margin: '3px' }} icon={faEye} />
        </Box>
      </Tooltip>
    </ClickAwayListener>
  );
};

export default VettingTokenTooltip;
